(function () {
    'use strict';

    angular.module('swif.openbase')
    .config(route)
    .factory('swifOpenbaseBarcodesService', swifOpenbaseBarcodesService)
    .controller('BarcodesController', BarcodesController);


    function route($routeProvider) {
        $routeProvider.when('/configuration/barcodes/table_view', {
            templateUrl: 'partials/openbase/barcodes_table_view.html',
            controller: 'BarcodesController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    /**
    * @ngdoc service
    * @name swif.openbase.swifOpenbaseBarcodesService
    * @requires swif.framework.swifFrameworkService
    **/
    function swifOpenbaseBarcodesService(swif, dataService, swifDownloadService) {
        'ngInject';
        var service = {};

        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate(
                'barcodes',
                'barcode_generator',
                filter,
                {location: true}
            );
        };

        service.createSettingsCollection = function () {
            var filter = {};
            var currentGenerator = service.getCollection().currentItem;
            if(currentGenerator) {
                swif.data.addExtraFilter(
                    filter,
                    'fromGenerator',
                    'generator_id',
                    '=',
                    currentGenerator.id
                );
            }

            return swif.collections.createOrUpdate(
                'barcode_settings',
                'barcode_setting',
                filter
            );
        };

        service.getSettingsCollection = function () {
            return swif.collections.getCollection('barcode_settings');
        };

        service.callback = function (error, data) {
            service.getCollection().defaultActionCallback(error, data);
        };

        service.preValidate = function (data) {
            return service.getCollection().preValidate(data);
        };

        service.getCollection = function () {
            return swif.collections.getCollection('barcodes');
        };

        //change in context item ids by barcode ids
        service.changeContextWithBarcodeIds = function (context, barcodeData) {
            for (var barcode of barcodeData) {
                context.items_params[barcode.id] = context.items_params[barcode.res_id];
                delete context.items_params[barcode.res_id];
            }
        };

        // TODO :factoriser le preValidate de collection.js
        // -- specifique service function for 'patrimoine_equipment' item(s) to print
        service.downloadReport = function (barcodeIds, model) {
            dataService.downloadReport(
                'patrimoine_equipment',
                'openbase.barcode.list',
                barcodeIds,
                model,
                model.context
            ).then(function () {
                if (model.printParams) {
                    swifDownloadService.params = model.printParams;
                }
                return true;
            }, function(err_msg) {
                throw new Error(err_msg);
            });
        };

        return service;
    }


    function BarcodesController($scope, swif, openbase) {
        'ngInject';
        var service = openbase.barcode;
        var download = swif.download;
        $scope.initialize = function () {
            service.createCollection().then(function () {
                var barcodes = service.getCollection();
                $scope.barcodes = barcodes;
                $scope.barcodes.downloader = {};
            });
            var filterService = {
                fields: ['id', 'name', 'complete_name'],
            };
            swif.data.addFilter(filterService, 'technical', '=', true);
            return swif.data.get(
                'department',
                undefined,
                filterService
            ).then(function (data) {
                $scope.services = data;
            });
        };

        $scope.initialize();

        $scope.getSettingServices = function (setting) {
            var ret = [];
            _.forEach(setting._service_ids, function (value, key) {
                if(value) {
                    ret.push(key);
                }
            });
            return ret;
        };

        var _prepareSettingContext = function (setting) {
            var params = {};
            var service_ids = [];
            _.forEach($scope.getSettingServices(setting), function (srv_id) {
                service_ids.push(parseInt(srv_id, 10));
            });
            params[setting.id] = {print: true, service_ids: service_ids};
            return params;
        };

        $scope.printSetting = function (setting) {
            var currentItem = service.getCollection().currentItem;
            var params = _prepareSettingContext(setting);
            var context = {report_ctx: params};
            swif.data.downloadReport(
                'barcode_generator',
                'openbase.barcode.label',
                currentItem.id,
                $scope.barcodes.downloader,
                context
            );
        };

        $scope.printAllSettings = function (barcode) {
            var currentItem = barcode;
            var params = {};
            // if a generator is selected, apply possible modfications to the report
            if(service.getCollection().currentItem) {
                _.forEach(service.getSettingsCollection().items, function (item) {
                    var settingParams = _prepareSettingContext(item);
                    _.merge(params, settingParams);
                });
            }
            // else, if not any generator is selected, launch a default report on all data
            var context = {report_ctx: params};
            swif.data.downloadReport(
                'barcode_generator',
                'openbase.barcode.label',
                currentItem.id,
                $scope.barcodes.downloader,
                context
            );
        };

        $scope.$watch('barcodes.currentItem', function (newV, oldV) {
            if(!angular.equals(newV, oldV) && newV) {
                service.createSettingsCollection().then(function () {
                    var data = service.getSettingsCollection();
                    _.forEach(data.items, function (item) {
                        item._service_ids = {};
                    });
                    $scope.barcode_settings = data;
                });
            }
        });

        $scope.$watch('barcodes.downloader.printParams', function (newV, oldV) {
            if(!angular.equals(newV, oldV) && newV) {
                download.params = newV;
            }
        });
    }

})();
